import { useState } from "react";
import CategorySelect from "./CategorySelect";
import StateSelect from "./StateSelect";
import SubcategorySelect from "./SubcategorySelect";

function SessionDetails({
  category, onCategoryChange,
  state, onStateChange,
  subcategory, onSubcategoryChange,
  value, onChange,
  onEffectsChange,
  medicineType,
}) {
  const handleStrainSelect = (strain) => {
    if (onEffectsChange && strain.Effects) {
      onEffectsChange(strain.Effects);
    }
  };

  const isMushroom = medicineType === "mushroom";
  const [isCustomSpecies, setIsCustomSpecies] = useState(false);
  
  const MUSHROOM_SPECIES = [
  {
    label: " -Gentler- ",
    options: [
      "Golden Teacher",
      "B+",
      "Mazatapec",
      "Ecuadorian",
      "Cambodia",
      "Puerto Rican",
      "Koh Samui",
    ],
  },
  {
    label: " -Stronger- ",
    options: [
      "Penis Envy",
      "Tidal Wave",
      "Blue Meanie",
      "McKennaii",
      "Transkei",
    ],
  },
  {
    label: " -Other Common Varieties- ",
    options: [
      "Albino A+",
      "Amazonian",
      "Hawaiian",
      "Huautla",
      "Lipa Yai",
      "Z-Strain",
    ],
  },
];

  const allSpecies = MUSHROOM_SPECIES.flatMap(group => group.options);

  return (
    <div className="SessionDetails">


{isMushroom ? (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>

  <label className="mushroom-species-label">
  <span>Type / Variety</span>

  <select
    value={isCustomSpecies ? "__custom__" : (allSpecies.includes(subcategory) ? subcategory : "")}
    onChange={(e) => {
      if (e.target.value === "__custom__") {
        setIsCustomSpecies(true);
        onSubcategoryChange("");
      } else {
        setIsCustomSpecies(false);
        onSubcategoryChange(e.target.value);
      }
    }}
  >
    <option value="">-- Select Type / Variety --</option>

    {MUSHROOM_SPECIES.map(group => (
      <optgroup key={group.label} label={group.label}>
        {group.options.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </optgroup>
    ))}

    <option value="__custom__">Other / Custom...</option>
  </select>

  {isCustomSpecies && (
    <input
      type="text"
      value={subcategory}
      placeholder="Type species name..."
      onChange={(e) => onSubcategoryChange(e.target.value)}
      style={{ marginTop: "8px" }}
    />
  )}
</label>

    <StateSelect value={state} onChange={onStateChange} isMushroom={isMushroom} />
  </div>
) : (
  <>
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
      <CategorySelect value={category} onChange={onCategoryChange} />
      <StateSelect value={state} onChange={onStateChange} isMushroom={isMushroom} />
    </div>
    <SubcategorySelect
      category={category}
      state={state}
      value={subcategory}
      onChange={onSubcategoryChange}
      onStrainSelect={handleStrainSelect}
    />
  </>
)}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
        <label>
          {isMushroom ? "Dose" : "Amount"}
          <input
            type="text"
            value={value.amount}
            placeholder={isMushroom ? "e.g. 0.1g micro · 1g low · 2.5g moderate · 3.5g high" : "e.g. 0.3g, 1 gummy, 2 drops"}
            onChange={(e) => onChange({ amount: e.target.value })}
          />
        </label>

        <label>
          {isMushroom ? "Form" : "Method"}
          <select
            value={value.method}
            onChange={(e) => onChange({ method: e.target.value })}
          >
            {isMushroom ? (
              <>
                <option value="">-- Select Form --</option>
                <option value="Dried">Dried</option>
                <option value="Tea">Tea</option>
                <option value="Lemon Tek">Lemon Tek</option>
                <option value="Capsule">Capsule</option>
                <option value="Chocolate">Chocolate</option>
                <option value="Gummy">Gummy</option>
                <option value="Tincture">Tincture</option>
                <option value="Other">Other</option>
              </>
            ) : (
              <>
                <option value="">-- Select Method --</option>
                <option value="Flower">Flower</option>
                <option value="Preroll">Preroll</option>
                <option value="Vape">Vape</option>
                <option value="Edible">Edible</option>
                <option value="Concentrate">Concentrate</option>
                <option value="Tincture">Tincture</option>
                <option value="Topical">Topical</option>
                <option value="Other">Other</option>
              </>
            )}
          </select>
        </label>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
        <label>
          Time of Day
          <select
            value={value.time_of_day}
            onChange={(e) => onChange({ time_of_day: e.target.value })}
          >
            <option value="">-- Select Time of Day --</option>
            <option value="Morning">Morning</option>
            <option value="Afternoon">Afternoon</option>
            <option value="Evening">Evening</option>
            <option value="Night">Night</option>
          </select>
        </label>

        <label>
          {isMushroom ? "Set & Setting Notes" : "Session Timing"}
          <input
            type="text"
            value={value.session_timing}
            placeholder={isMushroom ? "e.g. forest, ceremony, home alone..." : "e.g. after dinner, watching the sunset..."}
            onChange={(e) => onChange({ session_timing: e.target.value })}
          />
        </label>
      </div>

    </div>
  );
}

export default SessionDetails;